module.exports = __webpack_public_path__ + "static/media/user-solid.16069ca8.svg";